module.exports = __webpack_public_path__ + "static/img/lhkc.ed0c09a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lhkc.png
// module id = 6vk2
// module chunks = 15